// Brand assets — centralized, self-hosted under /public/images
export const LOGO_URL = "/images/logo.png";

// Real cap product photography
export const CAP_HERO = "/images/cap-hero.webp";
export const CAP_PRODUCT = "/images/cap-front.webp";
export const CAP_BACK = "/images/cap-back.webp";
export const CAP_DUO = "/images/cap-duo.webp";

export const LIFESTYLE_HERO = "/images/lifestyle-1.webp";

export const LIFESTYLE_2 = "/images/lifestyle-2.webp";

export const LIFESTYLE_3 = "/images/lifestyle-3.webp";

// Gallery: gym / surfing / Cabo / ambition
export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1434596922112-19c563067271?q=80&w=1400&auto=format&fit=crop",
    label: "GYM",
    span: "md:col-span-6 md:row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?q=80&w=1400&auto=format&fit=crop",
    label: "OCEAN",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1400&auto=format&fit=crop",
    label: "CABO",
    span: "md:col-span-3 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1400&auto=format&fit=crop",
    label: "DISCIPLINE",
    span: "md:col-span-3 md:row-span-1",
  },
  {
    url: "/images/lifestyle-2.webp",
    label: "COMMUNITY",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?q=80&w=1400&auto=format&fit=crop",
    label: "SUNSET",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?q=80&w=1400&auto=format&fit=crop",
    label: "SURF",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    url: "/images/lifestyle-3.webp",
    label: "BRAND",
    span: "md:col-span-4 md:row-span-1",
  },
];
